export default {
  Titulo: 'Endereço Exterior',
  Campos: {
    Cep: {
      Tipo: 'mask',
      Label: 'Código Postal',
      Tooltip: 'Código Postal',
      Placeholder: 'Código Postal',
      Mascara: 'CAIXAPOSTAL',
      Obrigatorio: true,
      Desabilitado: true,
    },
    Logradouro: {
      Tipo: 'suggestion',
      Label: 'Logradouro',
      Tooltip: 'Logradouro',
      Placeholder: 'Logradouro',
      Obrigatorio: true,
      Desabilitado: true,
    },
    Numero: {
      Tipo: 'number',
      Label: 'Número',
      Tooltip: 'Número',
      Placeholder: 'Número',
      Tamanho: 9,
      Desabilitado: true,
      Obrigatorio: true,
    },
    Complemento: {
      Tipo: 'text',
      Label: 'Complemento',
      Tooltip: 'Complemento',
      Placeholder: 'Complemento',
      Tamanho: 60,
      Desabilitado: true,
    },
    Bairro: {
      Tipo: 'suggestion',
      Label: 'Bairro/Distrito',
      Tooltip: 'Bairro/Distrito',
      Placeholder: 'Bairro/Distrito',
      Obrigatorio: true,
      Desabilitado: true,
    },
    Cidade: {
      Tipo: 'suggestion',
      Label: 'Cidade',
      Tooltip: 'Cidade',
      Placeholder: 'Cidade',
      Obrigatorio: true,
      Desabilitado: true,
    },
    UF: {
      Tipo: 'text',
      Label: 'Estado/Província',
      Tooltip: 'Estado/Província',
      Placeholder: 'Estado/Província',
      Tamanho: 2,
      Obrigatorio: true,
      Desabilitado: true,
    },
    Pais: {
      Tipo: 'suggestion',
      Label: 'País',
      Tooltip: 'País',
      Placeholder: 'País',
      Obrigatorio: true,
      Desabilitado: true,
    },
  },
};
